import { action, computed, observable } from 'mobx';
import { templateApi } from '@link/supplier/services';

export class TimeZone {
  @observable accessor timeZones: Array<string> = [];

  @action
  async getTimeZones() {
    const res = await templateApi.listTimeZones();

    const timeZones = (res?.timeZones || [])
      .map(tz => tz.tzIdentifier)
      .filter((tz): tz is string => typeof tz === 'string');

    this.setTimeZones(timeZones);

    return timeZones;
  }

  @action
  setTimeZones(timeZones: Array<string>) {
    this.timeZones = timeZones;
  }

  @computed
  get loaded(): boolean {
    return this.getTimeZones.length > 0;
  }
}

export default new TimeZone();
